/** Format a `YYYY-MM-DD` date as a long, locale-aware label (e.g. "June 15, 2040"). */
export function formatLongDate(iso: string): string {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}
